import { defineFcm } from '../shared/factory';

export const FCM_GROWTH_LEGAL_DISCLAIMER_UPDATE = defineFcm('growth_legal_disclaimer_update')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'PSF Membership Ask page',
		description: 'A new disclaimer was added, this FCM stands in place so non US users cannot see untranslated strings',
	});
